import { LogoutPage } from '@app/core/auth/flow';
import { App } from '@app/core/containers/App';
import { AppRoute } from '@app/core/routing/AppRoute';
import { Switch } from 'react-router-dom';

export function AppRootRoutes() {
  return (
    <Switch>
      <AppRoute path="/logout" component={LogoutPage} />
      <App />
    </Switch>
  );
}
